import { ConversationBuilderLocale } from "@/locales/localeid";
import { ConversationBuilderState } from "@/modules/conversation-builder";
import { ConversationBuilderService, MasterConversationDetailResponseModel } from "@/services/conversation-builder";
import { BuilderPageType } from "@/util/enum";
import { Button, Select } from "ant-design-vue";
import { fmtMsg } from "commonui";
import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import ConversationBuilder from "../../conversation-builder";
import { countDialogAndPaths, countObjects, EntityLengths } from "../../conversation-builder-util";
import { IMetaData, INodes } from "../../conversation-builder.model";

@Component({
	components: { Select, Button, SelectOption: Select.Option }
})
export default class ConversationMaster extends Vue {
	private conversationStore = getModule(ConversationBuilderState);

	public templates: MasterConversationDetailResponseModel[] = [];

	public selectedItem: MasterConversationDetailResponseModel | undefined;
	public loading: boolean = false;
	public copyingMasterDialog: boolean = false;

	$parent!: ConversationBuilder;

	created() {
		this.loading = true;
		ConversationBuilderService.getMasterConversations({ withMetadata: true }).then(
			(data) => {
				this.templates = data;
				this.loading = false;
			},
			() => {
				this.loading = false;
			}
		);
	}

	public onSelectTemplate(item: number) {
		this.selectedItem = this.templates[item];
	}

	public add() {
		if (this.selectedItem) {
			this.copyingMasterDialog = true;
			const masterConversationName = this.selectedItem.text;
			const svgSize = this.$parent.$refs.renderer.getSVGSize();
			const { id } = this.$route.params;
			const pageType = this.$route.params.pagetype as BuilderPageType;
			const metaData: IMetaData = JSON.parse(this.selectedItem.metaData) || { nodes: {}, entities: {}, intents: {} };

			this.conversationStore.pasteMetaData({
				metaData,
				svgSize,
				pageType,
				id,
				masterConversationName
			})
				.then((res) => {
					if (res.err) {
						this.$message.error(res.err);
					}
					this.copyingMasterDialog = false;
					const { nodes, entities, intents } = this.conversationStore;
					const { intentCount, entityCount } = countObjects(nodes, entities, intents);
					const { intent: maxIntents, entities: maxEntities } = EntityLengths.conversation.child;
					if (entityCount >= maxEntities) {
						this.$message.warning(
							fmtMsg(ConversationBuilderLocale.ConversationMaxNodeCountWarning, {
								node: "Entity",
								entityCount
							})
						);
					} else if (intentCount >= maxIntents) {
						this.$message.warning(
							fmtMsg(ConversationBuilderLocale.ConversationMaxNodeCountWarning, {
								node: "Intent",
								intentCount
							})
						);
					}
				});
		}
	}

	private validCount(nodesBeingAdded: INodes): boolean {
		const { dialogCount: curDCount, pathCount: curICount } = countDialogAndPaths(this.conversationStore.nodes);
		const { dialogCount: newDCount, pathCount: newICount } = countDialogAndPaths(nodesBeingAdded);
		const { path: maxIntents, dialog: maxDialogs } = EntityLengths.conversation.child;

		if (maxDialogs < curDCount + newDCount && maxIntents < curICount + newICount) {
			// show warning message
			this.$message.warning(
				`Dialog and intent count would be more than ${maxDialogs}, ${maxIntents} respectively. Please delete some dialogs and intents to add.`
			);
			return false;
		}

		if (maxDialogs < curDCount + newDCount) {
			// show warning message
			this.$message.warning(`Dialog count would be more than ${maxDialogs}. Please delete some dialogs.`);
			return false;
		}
		if (maxIntents < curICount + newICount) {
			this.$message.warning(`Intent count would be more than ${maxIntents}. Please delete some intents.`);
			// show warning message
			return false;
		}
		return true;
	}
}
